import * as Types from '../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WorkLocationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type WorkLocationsQuery = { __typename?: 'QueryModel', employees?: { __typename?: 'EmployeesQueryModel', workLocations?: Array<string> | null } | null };


export const WorkLocationsDocument = gql`
    query WorkLocations {
  employees {
    workLocations
  }
}
    `;

/**
 * __useWorkLocationsQuery__
 *
 * To run a query within a React component, call `useWorkLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkLocationsQuery(baseOptions?: Apollo.QueryHookOptions<WorkLocationsQuery, WorkLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkLocationsQuery, WorkLocationsQueryVariables>(WorkLocationsDocument, options);
      }
export function useWorkLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkLocationsQuery, WorkLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkLocationsQuery, WorkLocationsQueryVariables>(WorkLocationsDocument, options);
        }
export type WorkLocationsQueryHookResult = ReturnType<typeof useWorkLocationsQuery>;
export type WorkLocationsLazyQueryHookResult = ReturnType<typeof useWorkLocationsLazyQuery>;
export type WorkLocationsQueryResult = Apollo.QueryResult<WorkLocationsQuery, WorkLocationsQueryVariables>;